import {
  Mic, Folder, ListTree, Network, Clock, Voicemail, Users, ClipboardList,
  ShieldCheck, UserPlus, Phone, CreditCard, Building2, Briefcase,
  type LucideIcon,
} from 'lucide-react';
import type { EntityType } from '@/api/search';

export interface EntityMeta {
  label: string;
  icon: LucideIcon;
}

export const ENTITY_META: Record<EntityType, EntityMeta> = {
  recordings:        { label: 'Recordings',        icon: Mic },
  folders:           { label: 'Folders',           icon: Folder },
  ivr_trees:         { label: 'IVR Trees',         icon: ListTree },
  ivr_nodes:         { label: 'IVR Nodes',         icon: Network },
  time_frames:       { label: 'Time Frames',       icon: Clock },
  voicemail_boxes:   { label: 'Voicemail Boxes',   icon: Voicemail },
  conferences:       { label: 'Conferences',       icon: Users },
  surveys_quizzes:   { label: 'Surveys & Quizzes', icon: ClipboardList },
  auth_lists:        { label: 'Auth Lists',        icon: ShieldCheck },
  auth_list_entries: { label: 'Auth List Entries', icon: UserPlus },
  callers:           { label: 'Callers',           icon: Users },
  phone_numbers:     { label: 'Phone Numbers',     icon: Phone },
  payments:          { label: 'Payments',          icon: CreditCard },
  customers:         { label: 'Customers',         icon: Building2 },
  resellers:         { label: 'Resellers',         icon: Briefcase },
};

export const SEE_ALL_URL: Record<EntityType, (q: string) => string> = {
  recordings:        (q) => `/recordings?q=${encodeURIComponent(q)}`,
  folders:           (q) => `/folders?q=${encodeURIComponent(q)}`,
  ivr_trees:         (q) => `/ivr/trees?q=${encodeURIComponent(q)}`,
  ivr_nodes:         (q) => `/ivr/trees?q=${encodeURIComponent(q)}`,
  time_frames:       (q) => `/time-frames?q=${encodeURIComponent(q)}`,
  voicemail_boxes:   (q) => `/voicemails?q=${encodeURIComponent(q)}`,
  conferences:       (q) => `/conferences?q=${encodeURIComponent(q)}`,
  surveys_quizzes:   (q) => `/surveys?q=${encodeURIComponent(q)}`,
  auth_lists:        (q) => `/auth-lists?q=${encodeURIComponent(q)}`,
  auth_list_entries: (q) => `/auth-lists?q=${encodeURIComponent(q)}`,
  callers:           (q) => `/caller-profiles?q=${encodeURIComponent(q)}`,
  phone_numbers:     (q) => `/dids?q=${encodeURIComponent(q)}`,
  payments:          (q) => `/charges?q=${encodeURIComponent(q)}`,
  customers:         (q) => `/customers?q=${encodeURIComponent(q)}`,
  resellers:         (q) => `/resellers?q=${encodeURIComponent(q)}`,
};
